import Stats from "stats.js";
import { useEffect } from "react";

function PerformanceMonitor() {
  useEffect(() => {
    const stats = new Stats();
    stats.showPanel(0); // 0 = FPS, 1 = MS, 2 = MB
    document.body.appendChild(stats.dom);

    function animate() {
      stats.begin();
      stats.end();
      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);
  }, []);

  return null;
}

export default PerformanceMonitor;